import { For, lazy, Show } from "solid-js";
import c from "class-c";

import CommunityPost from "@repo/kikoff-models/community/CommunityPost";

import { usePosts } from "~/state/features/posts";

import ProfileBadge from "../profile/ProfileBadge";
import ChipContainer from "../shared/ChipContainer";

import PostLike from "./PostLike";
import PostTimer from "./PostTimer";
import Tag from "./Tag";

import styles from "./PostContent.module.scss";

const AdminActions = lazy(() => import("../admin/AdminActions"));

declare namespace PostContent {
  interface Props {
    post: CommunityPost;
    class?: string;
    lineClamp?: number;
  }
}

function PostContent({
  post,
  class: className,
  lineClamp,
}: D<PostContent.Props>) {
  const [posts] = usePosts();

  return (
    <div class={className}>
      <div class="row-center">
        <Show when={post.isPinned && !post.parentId}>
          <div class="icon:medium mb-1 mr-0.5"></div>
        </Show>
        <div class="mb-1 expand text:regular+">
          <ProfileBadge.WithAvatar
            profileId={post.authorId}
            after={<PostTimer post={post} class="ml-0.5" />}
          />
        </div>
        {/* Following to be hidden for now */}
        {/* <ContainerButton
          class={`${styles.follow} icon:small mr-2`}
          onClick={(e) => {
            e.preventDefault();

            setPosts[posts.userIsFollowingFor(post.id) ? "unfollow" : "follow"](
              post.id,
            )?.catch((e) => {
              error.capture(e);
            });
          }}
        >
          {posts.userIsFollowingFor(post.id) ? "" : ""}
        </ContainerButton> */}
      </div>
      <header class={c`text:heading-4+ mb-1 ${styles["title"]}`}>
        {post.title}
      </header>
      <For each={post.tagIds}>
        {(tagId) => (
          <Show when={posts.tagById(tagId)}>
            {(tag) => (
              <Tag class="mr-1 mb-1" name={tag().name} color={tag().color} />
            )}
          </Show>
        )}
      </For>

      <div
        class={c`${styles.content} ${lineClamp && styles["truncate"]} mb-1.5`}
        style={{ "--line-clamp": lineClamp }}
      >
        {post.bodyMd}
      </div>
      <div class="text:small">
        <PostLike post={post} class="mr-1" />
        <ChipContainer class="mr-1">
          <span class="icon:small mr-0.5"></span>{" "}
          {post.replyIds.length !== 0 ? post.replyIds.length : "Reply"}
        </ChipContainer>
        <AdminActions post={post} />
      </div>
    </div>
  );
}

export default PostContent;
